(function (window) {
  if (!window || window.BumpJackpotPoller) {
    return;
  }

  var state = {
    endpoint: "",
    eventNumber: "",
    intervalMs: 30000,
    timerId: null,
    inFlightRequest: null,
    lastPayload: null,
    lastUpdatedAt: 0,
    subscribers: [],
    nextSubscriberId: 1,
  };

  function normalizeText(value) {
    if (value === null || typeof value === "undefined") {
      return "";
    }

    return String(value);
  }

  function normalizeNumber(value) {
    var parsedValue = Number(value);

    if (!window.Number.isFinite(parsedValue)) {
      return 0;
    }

    return parsedValue;
  }

  function formatGroupedInteger(value, separator) {
    var roundedValue = window.Math.max(0, window.Math.round(normalizeNumber(value)));
    var digits = String(roundedValue);

    if (!separator) {
      return digits;
    }

    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  function getCurrentLocale() {
    var currentLang = "";

    if (window.Weglot && typeof window.Weglot.getCurrentLang === "function") {
      currentLang = normalizeText(window.Weglot.getCurrentLang()).toLowerCase();
    }

    if (currentLang.indexOf("fr") === 0) {
      return "fr";
    }

    return "en";
  }

  function formatLocalizedCurrency(localizedValue, numericValue) {
    var normalizedLocalizedValue = normalizeText(localizedValue);
    var normalizedNumericValue = normalizeNumber(numericValue);

    if (!normalizedNumericValue) {
      return normalizedLocalizedValue;
    }

    if (getCurrentLocale() === "fr") {
      return formatGroupedInteger(normalizedNumericValue, "\u00a0") + "$";
    }

    if (normalizedLocalizedValue) {
      return normalizedLocalizedValue;
    }

    return "$" + formatGroupedInteger(normalizedNumericValue, ",");
  }

  function trimTrailingSlash(value) {
    return normalizeText(value).replace(/\/+$/, "");
  }

  function getAddons(eventDetail) {
    if (eventDetail && window.Array.isArray(eventDetail.addons)) {
      return eventDetail.addons;
    }

    if (eventDetail && window.Array.isArray(eventDetail.addonData)) {
      return eventDetail.addonData;
    }

    return [];
  }

  function getLocalizedValue(source, snakeCaseKey, camelCaseKey) {
    if (!source) {
      return "";
    }

    if (source[snakeCaseKey]) {
      return normalizeText(source[snakeCaseKey]);
    }

    if (source[camelCaseKey]) {
      return normalizeText(source[camelCaseKey]);
    }

    return "";
  }

  function getNumericValue(source, snakeCaseKey, camelCaseKey) {
    if (!source) {
      return 0;
    }

    if (typeof source[snakeCaseKey] !== "undefined") {
      return normalizeNumber(source[snakeCaseKey]);
    }

    if (typeof source[camelCaseKey] !== "undefined") {
      return normalizeNumber(source[camelCaseKey]);
    }

    return 0;
  }

  function normalizePayload(eventDetail) {
    var normalizedEventDetail = eventDetail || {};
    var firstAddon = getAddons(normalizedEventDetail)[0] || null;
    var mainJackpotLocalized = getLocalizedValue(normalizedEventDetail, "jackpot_localized", "jackpotLocalized");
    var mainPrizeLocalized = getLocalizedValue(normalizedEventDetail, "prize_localized", "prizeLocalized");
    var addonJackpotLocalized = getLocalizedValue(firstAddon, "jackpot_localized", "jackpotLocalized");
    var addonPrizeLocalized = getLocalizedValue(firstAddon, "prize_localized", "prizeLocalized");
    var mainJackpotNumber = getNumericValue(normalizedEventDetail, "jackpot", "jackpot");
    var mainPrizeNumber = getNumericValue(normalizedEventDetail, "prize", "prize");
    var addonJackpotNumber = getNumericValue(firstAddon, "jackpot", "jackpot");
    var addonPrizeNumber = getNumericValue(firstAddon, "prize", "prize");

    return {
      raw: normalizedEventDetail,
      updatedAt: window.Date.now(),
      mainJackpotLocalized: mainJackpotLocalized,
      mainPrizeLocalized: mainPrizeLocalized,
      mainJackpotNumber: mainJackpotNumber,
      mainPrizeNumber: mainPrizeNumber,
      addonJackpotLocalized: addonJackpotLocalized,
      addonPrizeLocalized: addonPrizeLocalized,
      addonJackpotNumber: addonJackpotNumber,
      addonPrizeNumber: addonPrizeNumber,
      displayMainJackpotLocalized: formatLocalizedCurrency(mainJackpotLocalized, mainJackpotNumber),
      displayAddonJackpotLocalized: formatLocalizedCurrency(addonJackpotLocalized, addonJackpotNumber),
      displayMainPrizeLocalized: formatLocalizedCurrency(mainPrizeLocalized, mainPrizeNumber),
      displayAddonPrizeLocalized: formatLocalizedCurrency(addonPrizeLocalized, addonPrizeNumber),
      firstAddon: firstAddon,
      addons: getAddons(normalizedEventDetail),
    };
  }

  function createNoopHandle() {
    return {
      unsubscribe: function () {},
      setEnabled: function () {},
    };
  }

  function countActiveSubscribers() {
    var activeCount = 0;
    var index;

    for (index = 0; index < state.subscribers.length; index += 1) {
      if (state.subscribers[index].enabled) {
        activeCount += 1;
      }
    }

    return activeCount;
  }

  function hasActiveSubscribers() {
    return state.subscribers.some(function (subscriber) {
      return subscriber.enabled;
    });
  }

  function buildRequestUrl() {
    if (!state.endpoint || state.eventNumber === "" || state.eventNumber === null) {
      return "";
    }

    return trimTrailingSlash(state.endpoint) + "/api/web/event/" + window.encodeURIComponent(normalizeText(state.eventNumber));
  }

  function clearTimer() {
    if (state.timerId) {
      window.clearTimeout(state.timerId);
      state.timerId = null;
    }
  }

  function safelyNotifySubscriber(subscriber, payload) {
    if (!subscriber || !subscriber.enabled || typeof subscriber.onUpdate !== "function") {
      return;
    }

    try {
      subscriber.onUpdate(payload);
    } catch (error) {
      if (window.console && typeof window.console.error === "function") {
        window.console.error("BumpJackpotPoller subscriber update failed", error);
      }
    }
  }

  function notifySubscribers(payload) {
    var subscribersSnapshot = state.subscribers.slice();
    var index;

    for (index = 0; index < subscribersSnapshot.length; index += 1) {
      safelyNotifySubscriber(subscribersSnapshot[index], payload);
    }
  }

  function runWhenDocumentReady(callback) {
    if (!window.document) {
      return;
    }

    if (window.document.readyState === "loading") {
      window.document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function resolveTargetElement(options) {
    var rootElement;

    if (!window.document) {
      return null;
    }

    rootElement = options.rootSelector ? window.document.querySelector(options.rootSelector) : window.document;

    if (!rootElement) {
      return null;
    }

    return rootElement.querySelector(options.targetSelector || "[data-bump-main-jackpot-target]");
  }

  function resolveTargetText(targetElement, payload, options) {
    var nextText = "";
    var fallbackAttribute = options.fallbackAttribute || "data-bump-jackpot-fallback";

    if (payload && options.payloadKey && payload[options.payloadKey]) {
      nextText = payload[options.payloadKey];
    }

    if (!nextText) {
      nextText = targetElement.getAttribute(fallbackAttribute) || targetElement.textContent;
    }

    return nextText;
  }

  function copyComputedTextStyles(sourceElement, targetElement) {
    var computedStyle;
    var textStyleProperties;
    var index;

    if (!window.getComputedStyle || !sourceElement || !targetElement) {
      return;
    }

    computedStyle = window.getComputedStyle(sourceElement);
    textStyleProperties = [
      "font",
      "fontFamily",
      "fontFeatureSettings",
      "fontKerning",
      "fontSize",
      "fontStretch",
      "fontStyle",
      "fontVariant",
      "fontVariantNumeric",
      "fontWeight",
      "letterSpacing",
      "lineHeight",
      "textTransform",
      "wordSpacing",
    ];

    for (index = 0; index < textStyleProperties.length; index += 1) {
      if (computedStyle[textStyleProperties[index]]) {
        targetElement.style[textStyleProperties[index]] = computedStyle[textStyleProperties[index]];
      }
    }
  }

  function buildWidestTickerText(text) {
    return normalizeText(text).replace(/\d/g, "8");
  }

  function measureTextWidth(targetElement, nextText) {
    var measurementNode;
    var measuredWidth = 0;

    if (!window.document || !window.document.body || !targetElement) {
      return measuredWidth;
    }

    measurementNode = targetElement.cloneNode(false);
    measurementNode.textContent = nextText;
    measurementNode.style.position = "absolute";
    measurementNode.style.visibility = "hidden";
    measurementNode.style.pointerEvents = "none";
    measurementNode.style.left = "-9999px";
    measurementNode.style.top = "0";
    measurementNode.style.width = "auto";
    measurementNode.style.minWidth = "0";
    measurementNode.style.maxWidth = "none";
    measurementNode.style.whiteSpace = "nowrap";
    measurementNode.style.display = "inline-block";
    copyComputedTextStyles(targetElement, measurementNode);

    window.document.body.appendChild(measurementNode);
    measuredWidth = measurementNode.getBoundingClientRect().width;
    measurementNode.parentNode.removeChild(measurementNode);

    return measuredWidth;
  }

  function reserveAnimatedWidth(targetElement, nextText) {
    var currentWidth;
    var targetWidth;
    var widestTargetText;
    var widestTargetWidth;
    var existingMinWidth;
    var reservedWidth;

    if (!targetElement || !nextText) {
      return;
    }

    currentWidth = targetElement.getBoundingClientRect ? targetElement.getBoundingClientRect().width : 0;
    targetWidth = measureTextWidth(targetElement, nextText);
    widestTargetText = buildWidestTickerText(nextText);
    widestTargetWidth = widestTargetText ? measureTextWidth(targetElement, widestTargetText) : 0;
    existingMinWidth = parseFloat(targetElement.style.minWidth) || 0;
    reservedWidth = Math.max(currentWidth, targetWidth, widestTargetWidth, existingMinWidth);

    targetElement.style.display = "inline-block";
    targetElement.style.whiteSpace = "nowrap";

    if (typeof targetElement.style.fontVariantNumeric !== "undefined") {
      targetElement.style.fontVariantNumeric = "tabular-nums";
    }

    if (reservedWidth > 0) {
      targetElement.style.minWidth = Math.ceil(reservedWidth) + "px";
    }
  }

  function applyTargetText(targetElement, nextText, options) {
    if (options.animate && window.BumpJackpotTicker) {
      reserveAnimatedWidth(targetElement, nextText);
      window.BumpJackpotTicker.animateValue(targetElement, nextText);
      return;
    }

    targetElement.textContent = nextText;
  }

  function scheduleNextPoll() {
    clearTimer();

    if (!hasActiveSubscribers() || !buildRequestUrl()) {
      return;
    }

    state.timerId = window.setTimeout(function () {
      requestLatestPayload();
    }, state.intervalMs);
  }

  function stopPolling() {
    clearTimer();
    state.inFlightRequest = null;
    return getSnapshot();
  }

  function completeRequest() {
    state.inFlightRequest = null;
    scheduleNextPoll();
  }

  function handleRequestSuccess(eventDetail) {
    var payload = normalizePayload(eventDetail);

    state.lastPayload = payload;
    state.lastUpdatedAt = payload.updatedAt;
    notifySubscribers(payload);
    completeRequest();
  }

  function handleRequestFailure(error) {
    if (window.console && typeof window.console.error === "function") {
      window.console.error("BumpJackpotPoller request failed", error);
    }

    completeRequest();
  }

  function requestLatestPayload() {
    var requestUrl;

    if (!hasActiveSubscribers()) {
      return stopPolling();
    }

    requestUrl = buildRequestUrl();

    if (!requestUrl) {
      return getSnapshot();
    }

    if (state.inFlightRequest) {
      return getSnapshot();
    }

    state.inFlightRequest = new window.XMLHttpRequest();
    state.inFlightRequest.open("GET", requestUrl, true);
    state.inFlightRequest.onreadystatechange = function () {
      var request = state.inFlightRequest;
      var statusIsGood;
      var responseData;

      if (!request || request.readyState !== window.XMLHttpRequest.DONE) {
        return;
      }

      statusIsGood = request.status === 0 || (request.status >= 200 && request.status < 400);

      if (!statusIsGood) {
        handleRequestFailure(new window.Error("Request failed with status " + request.status));
        return;
      }

      try {
        responseData = window.JSON.parse(request.responseText);
      } catch (error) {
        handleRequestFailure(error);
        return;
      }

      handleRequestSuccess(responseData);
    };

    state.inFlightRequest.onerror = function () {
      handleRequestFailure(new window.Error("Network error while polling jackpot data"));
    };

    state.inFlightRequest.send(null);
    return getSnapshot();
  }

  function ensurePolling() {
    if (!hasActiveSubscribers()) {
      stopPolling();
      return getSnapshot();
    }

    if (!buildRequestUrl()) {
      return getSnapshot();
    }

    if (state.lastPayload) {
      scheduleNextPoll();
      return getSnapshot();
    }

    if (!state.inFlightRequest) {
      requestLatestPayload();
    }

    return getSnapshot();
  }

  function configure(options) {
    var nextEndpoint;
    var nextEventNumber;
    var nextIntervalMs;

    if (!options) {
      return true;
    }

    if (options.endpoint) {
      nextEndpoint = trimTrailingSlash(options.endpoint);

      if (state.endpoint && state.endpoint !== nextEndpoint) {
        return false;
      }

      state.endpoint = nextEndpoint;
    }

    if (typeof options.eventNumber !== "undefined" && options.eventNumber !== null && options.eventNumber !== "") {
      nextEventNumber = normalizeText(options.eventNumber);

      if (state.eventNumber && state.eventNumber !== nextEventNumber) {
        return false;
      }

      state.eventNumber = nextEventNumber;
    }

    if (typeof options.intervalMs !== "undefined") {
      nextIntervalMs = normalizeNumber(options.intervalMs);

      if (nextIntervalMs > 0) {
        state.intervalMs = window.Math.min(state.intervalMs, nextIntervalMs);
      }
    }

    return true;
  }

  function removeSubscriber(subscriberId) {
    var nextSubscribers = [];
    var index;

    for (index = 0; index < state.subscribers.length; index += 1) {
      if (state.subscribers[index].id !== subscriberId) {
        nextSubscribers.push(state.subscribers[index]);
      }
    }

    state.subscribers = nextSubscribers;

    if (!hasActiveSubscribers()) {
      stopPolling();
    }
  }

  function setSubscriberEnabled(subscriberId, enabled) {
    var index;

    for (index = 0; index < state.subscribers.length; index += 1) {
      if (state.subscribers[index].id === subscriberId) {
        state.subscribers[index].enabled = enabled !== false;

        if (state.subscribers[index].enabled && state.lastPayload) {
          safelyNotifySubscriber(state.subscribers[index], state.lastPayload);
        }

        break;
      }
    }

    ensurePolling();
    return getSnapshot();
  }

  function subscribe(options) {
    var normalizedOptions = options || {};
    var configurationAccepted = configure(normalizedOptions);
    var subscriber;

    if (typeof normalizedOptions.onUpdate !== "function") {
      return {
        id: null,
        unsubscribe: function () {},
        setEnabled: function () {},
      };
    }

    if (!configurationAccepted) {
      return {
        id: null,
        unsubscribe: function () {},
        setEnabled: function () {},
      };
    }

    subscriber = {
      id: state.nextSubscriberId,
      enabled: normalizedOptions.enabled !== false,
      onUpdate: normalizedOptions.onUpdate,
    };

    state.nextSubscriberId += 1;
    state.subscribers.push(subscriber);

    if (subscriber.enabled && state.lastPayload && normalizedOptions.useCachedPayload !== false) {
      safelyNotifySubscriber(subscriber, state.lastPayload);
    }

    if (subscriber.enabled && normalizedOptions.refreshOnSubscribe) {
      clearTimer();
      requestLatestPayload();
    } else {
      ensurePolling();
    }

    return {
      id: subscriber.id,
      unsubscribe: function () {
        removeSubscriber(subscriber.id);
      },
      setEnabled: function (enabled) {
        setSubscriberEnabled(subscriber.id, enabled);
      },
    };
  }

  function attachTextSubscriber(options) {
    var normalizedOptions = options || {};
    var subscriptionHandle = createNoopHandle();

    if (!normalizedOptions.enabled) {
      return subscriptionHandle;
    }

    runWhenDocumentReady(function () {
      var targetElement = resolveTargetElement(normalizedOptions);

      if (!targetElement || !/^\d+$/.test(String(normalizedOptions.eventNumber || ""))) {
        return;
      }

      subscriptionHandle = subscribe({
        endpoint: normalizedOptions.endpoint,
        eventNumber: normalizedOptions.eventNumber,
        intervalMs: normalizedOptions.intervalMs,
        enabled: true,
        refreshOnSubscribe: true,
        useCachedPayload: false,
        onUpdate: function (payload) {
          var nextText = resolveTargetText(targetElement, payload, normalizedOptions);

          if (!nextText) {
            return;
          }

          applyTargetText(targetElement, nextText, normalizedOptions);
        },
      });
    });

    return {
      unsubscribe: function () {
        subscriptionHandle.unsubscribe();
      },
      setEnabled: function (enabled) {
        subscriptionHandle.setEnabled(enabled);
      },
    };
  }

  function flushQueuedSubscribers() {
    var queuedSubscribers = window.BumpJackpotSubscriberQueue || [];
    var index;

    window.BumpJackpotSubscriberQueue = [];

    for (index = 0; index < queuedSubscribers.length; index += 1) {
      attachTextSubscriber(queuedSubscribers[index]);
    }
  }

  function getSnapshot() {
    return {
      endpoint: state.endpoint,
      eventNumber: state.eventNumber,
      intervalMs: state.intervalMs,
      updatedAt: state.lastUpdatedAt,
      lastPayload: state.lastPayload,
      subscriberCount: state.subscribers.length,
      activeSubscriberCount: countActiveSubscribers(),
      isPolling: !!state.timerId,
      hasInFlightRequest: !!state.inFlightRequest,
    };
  }

  window.BumpJackpotPoller = {
    attachTextSubscriber: attachTextSubscriber,
    configure: configure,
    flushQueuedSubscribers: flushQueuedSubscribers,
    subscribe: subscribe,
    refresh: requestLatestPayload,
    stop: stopPolling,
    getSnapshot: getSnapshot,
    normalizePayload: normalizePayload,
  };

  flushQueuedSubscribers();
})(window);